module.exports = __webpack_public_path__ + "img/9791159614002.5e23f06a.jpg";